import type { ReactNode } from 'react';
import { Theme, css } from '@emotion/react';
import { Banner, BannerProps } from 'client/components/Banner';
import { layoutStyles } from 'client/Theme';

interface AlertBannerProps {
  button: BannerProps['button'];
  children: ReactNode;
}

export const AlertBanner = (props: AlertBannerProps) => {
  return (
    <article css={alertStyle}>
      <Banner type="warning" {...props} css={bannerStyle} />
    </article>
  );
};

const alertStyle = (theme: Theme) => css`
  position: relative;
  margin-top: -2px;
  background-color: ${theme.color.yellow[60]};
  border: 2px solid ${theme.color.yellow[80]};
  border-left: none;
  border-right: none;
`;

const bannerStyle = (theme: Theme) => css`
  ${layoutStyles}

  ${theme.mediaQuery.large(css`
    padding-left: 0;
    padding-right: 0;
  `)}

  button.button {
    background-color: ${theme.color.yellow[80]};
  }
`;
